import { Controller } from "@hotwired/stimulus"

// Nav du constructeur : les étapes se réordonnent au glisser-déposer (poignée). Le dépôt envoie
// l'ordre complet (ReorderFormSteps) ; la page n'est rechargée qu'en cas de refus.
export default class extends Controller {
  static targets = ["row"]
  static values = { url: String, enabled: Boolean }

  connect() {
    if (!this.enabledValue) return
    this.onDragOver = this.dragOver.bind(this)
    this.onDrop = this.drop.bind(this)
    this.element.addEventListener("dragover", this.onDragOver)
    this.element.addEventListener("drop", this.onDrop)
  }

  disconnect() {
    if (!this.onDragOver) return
    this.element.removeEventListener("dragover", this.onDragOver)
    this.element.removeEventListener("drop", this.onDrop)
  }

  dragStart(event) {
    this.dragged = event.currentTarget.closest("[data-step-id]")
    this.dragged.classList.add("fields-form-nav__row--dragging")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.dragged.dataset.stepId)
  }

  // `drop` efface this.dragged : s'il est encore là, le glisser a été annulé ou lâché hors de la
  // nav alors que dragOver a déjà réordonné le DOM, on revient à l'état du serveur.
  dragEnd() {
    if (!this.dragged) return
    this.dragged.classList.remove("fields-form-nav__row--dragging")
    this.dragged = null
    this.reload()
  }

  reload() {
    window.Turbo.visit(window.location.href, { action: "replace" })
  }

  dragOver(event) {
    if (!this.dragged) return
    event.preventDefault()
    const row = event.target.closest("[data-step-id]")
    if (!row || row === this.dragged) return
    const box = row.getBoundingClientRect()
    const after = event.clientY > box.top + box.height / 2
    row.parentNode.insertBefore(this.dragged, after ? row.nextSibling : row)
  }

  async drop(event) {
    if (!this.dragged) return
    event.preventDefault()
    this.dragged.classList.remove("fields-form-nav__row--dragging")
    this.dragged = null
    const order = this.rowTargets.map((row) => Number(row.dataset.stepId))
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new FormData()
    body.append("order", JSON.stringify(order))
    let ok
    try {
      const response = await fetch(this.urlValue, { method: "POST", body, headers: { "X-CSRF-Token": token } })
      ok = response.ok
    } catch {
      ok = false
    }
    if (!ok) this.reload()
  }
}
